function Logo(props) {
    return (
        <div className="flex items-center justify-center py-2 px-2">
            <img
                src="/icon.png"
                alt="TellerPoint Logo"
                className="w-10 h-10 object-contain"
            />
        </div>
    );
}

export default Logo;
